
angular.module('membership')
  .controller('PersonalInfoCtrl', [
    '$scope', 'personalInfoViewModel',
    function($scope, model) {
      $scope.model = model;
      $scope.model.init($scope.userId);
    }
  ])